import { useEffect, useRef } from 'react';
import { useGoogleMaps } from './GoogleMapsProvider';

const MapDisplay = ({ location , idMap , dict}) => {
  const mapRef = useRef(null);
  const mapInstanceRef = useRef(null); 
  const markerRef = useRef(null);
  const { isLoaded } = useGoogleMaps();

  useEffect(() => {
    if (!isLoaded) return;

    const initMap = async () => {
      if (!window.google || !window.google.maps || !window.google.maps.Map) return;

      const AdvancedMarkerElement = google.maps.marker?.AdvancedMarkerElement;

      const map = new google.maps.Map(mapRef.current, {
        zoom: 15,
        center: location || { lat: dict.map.lat, lng: dict.map.lng },
        mapId: idMap,
        draggable: false,
        zoomControl: true,
        scrollwheel: false,
        disableDoubleClickZoom: true,
      });

      if (AdvancedMarkerElement) {
        const markerEl = document.createElement('div');
        markerEl.innerHTML = `
          <div style="display:flex;flex-direction:column;align-items:center;cursor:pointer;">
            <div style="width:48px;height:48px;border-radius:50%;background:#EE4424;display:flex;align-items:center;justify-content:center;">
              <svg xmlns="http://www.w3.org/2000/svg" width="22" height="26" fill="none" viewBox="0 0 22 26">
                <g clip-path="url(#hop-marker-clip)">
                  <path fill="#22CDC6" d="M21.567 4.38a.798.798 0 00-.21-.389c-.015-.015-.032-.028-.048-.042h-.002l-.716-.598-1.986-1.656L17.006.367a.451.451 0 00-.37-.058L.977 4.194a.74.74 0 00-.398.276.796.796 0 00-.167.475v15.89c0 .167.063.304.165.388l4.947 4.121a.62.62 0 00.07.048.459.459 0 00.329.031l15.09-3.743a.624.624 0 00.15-.06.819.819 0 00.416-.692v-3.487s.005.01.01.015V4.569a.797.797 0 00-.022-.189z"></path>
                  <path fill="#FEFEFE" d="M20.443 5.841v14.49c0 .146-.108.29-.243.325l-4.57 1.133c-.134.033-.243-.057-.243-.202V17.11c0-.147-.11-.237-.244-.203l-3.683.916a.34.34 0 00-.243.321v4.476c0 .145-.108.29-.243.323l-4.57 1.134c-.134.033-.243-.058-.243-.202V9.384c0-.144.11-.29.243-.323l4.57-1.134c.135-.033.243.057.243.204v4.486c0 .147.11.237.243.203l3.683-.912a.35.35 0 00.244-.325V7.096c0-.146.11-.291.243-.324l.348-.086.17-.043.025-.005.66-.163 3.367-.836c.135-.034.243.056.243.202z"></path>
                </g>
                <defs><clipPath id="hop-marker-clip"><path fill="#fff" d="M0 0H21.177V25.147H0z" transform="translate(.412 .294)"></path></clipPath></defs>
              </svg>
            </div>
            <div style="width:0;height:0;border-left:8px solid transparent;border-right:8px solid transparent;border-top:8px solid #EE4424;margin-top:-1px;"></div>
          </div>
        `;

        const marker = new AdvancedMarkerElement({
          map,
          position: location,
          title: 'Ubicación',
          content: markerEl,
        });
        markerRef.current = marker;
      }

      mapInstanceRef.current = map;
    };

    initMap();
    // El mapa se inicializa una sola vez al cargar Google Maps.
    // Los cambios de location/center se manejan en el effect de abajo.
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isLoaded]);

  useEffect(() => {
    if (markerRef.current && location) {
      markerRef.current.position = location;
    }
    if (mapInstanceRef.current && location) {
      mapInstanceRef.current.setCenter(location);
    }
  }, [location]);

  return <div ref={mapRef} style={{ width: '100%', height: '400px', marginTop: '1rem' }} />;
};

export default MapDisplay;

